import { useState } from "react";
import { makeStyles } from "tss-react/mui";
import { MiIcon, MiLoader } from "@miplatform/components";
import { addAlpha } from "@miplatform/utils";
import { mdiMagnify } from "@mdi/js";
import { Box, InputBase } from "@mui/material";
import { HomeSearchAutocomplete } from "../../../views/Homes/components/HomeSearchAutocomplete";

const renderInput = ({ params, isLoading, theme, classes }) => {
  const { InputProps } = params;
  return (
    <InputBase
      {...params}
      {...InputProps}
      fullWidth
      data-testid="global-home-search"
      placeholder="Global Search"
      slotProps={{
        input: {
          ...params.inputProps,
          className: classes.searchBarField,
        },
      }}
      startAdornment={
        <MiIcon className={classes.searchIcon} path={mdiMagnify} size={1} />
      }
      endAdornment={
        <span className={classes.inputEndAdornments}>
          <MiLoader
            isLoading={isLoading}
            className={classes.loader}
            loaderColor={theme.palette.common.white}
            size={20}
          />
        </span>
      }
    />
  );
};

export function SearchBar() {
  const [searchText, setSearchText] = useState("");

  const handleSearchChange = (newSearchText) => {
    setSearchText(() => newSearchText);
  };

  const handleClearSearch = () => {
    setSearchText("");
  };

  const { classes, theme } = useStyles();

  return (
    <Box className={classes.rootContainer}>
      <HomeSearchAutocomplete
        search={searchText}
        onClearSearch={handleClearSearch}
        onSearchChange={handleSearchChange}
        width="100%"
        iconColor={theme.palette.common.white}
        renderInput={(params) =>
          renderInput({
            params,
            classes,
            theme,
          })
        }
        clearOnBlur
      />
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  rootContainer: {
    borderRadius: 24,
    backgroundColor: addAlpha(theme.palette.common.white, 2),
    width: "100%",
    display: "flex",
    alignItems: "center",
    flex: 1,
  },
  searchBarField: {
    width: "100%",
    fontSize: theme.fontSize.medium,
    color: theme.palette.common.white,
    paddingBottom: 0,
  },
  searchIcon: {
    margin: 8,
    color: theme.palette.common.white,
  },
  inputEndAdornments: {
    display: "flex",
    flexDirection: "row",
    height: 20,
    marginRight: 10,
  },
}));
